@if(isLoading()){
  <app-preloader></app-preloader>
}
<app-img-header
  title="Descargas"
  alt="Descargas"
  image="/assets/images/descargas/intro.jpg"
  [contentTemplate]="template"
>
</app-img-header>
<main class="main" id="">
  <div id="detail" class="white">
    <div class="pageWidth">
      <div class="actionsWrapper">
        <div class="switchView">
          <a class="list" [class.active]="!isGridView" (click)="switchView(false)" tp="Ver descargas en lista"
            >Ver descargas en lista</a
          >
          <a class="grid" [class.active]="isGridView" (click)="switchView(true)" tp="Ver descargas en grilla"
            >Ver descargas en grilla</a
          >
        </div>
      </div>
      <div *ngIf="!hasData" class="noData">No hay información para mostrar</div>

      <!-- Tabla con descargas -->
      <div class="customTableWrapper" *ngIf="!isGridView && hasData">
        <div class="customTable listadoDescargas">
          <div class="header">
            <div class="cell creacion">Creación</div>
            <div class="cell titulo">Título</div>
            <div class="cell descripcion">Descripción</div>
            <div class="cell categoría">Categoría</div>
            <div class="cell departamento">Departamento</div>
            <div class="cell acciones"></div>
          </div>

          <div class="row" *ngFor="let download of downloads">
            <div class="cell creacion">
              {{ formatDate(download.creationDate) }}
            </div>
            <div class="cell titulo">{{ download.originalName }}</div>
            <div class="cell descripcion">{{ download.description }}</div>
            <div class="cell categoría">
              {{ getCategoryLabel(download.categoryType) }}
            </div>
            <div class="cell departamento">
              {{ getDepartmentLabel(download.departmentType) }}
            </div>
            <div class="cell acciones">
              <a
                tp="Descargar"
                class="download"
                (click)="handleDownloadFile(download.id)"
                >Descargar</a
              >
            </div>
          </div>
        </div>
      </div>

      <!-- Grilla con descargas -->
      <div class="customGrid descargas" *ngIf="isGridView && hasData">
        <div class="card" *ngFor="let download of downloads">
          <div class="area">
            <i class="icon">{{ getCategoryIcon(download.categoryType) }}</i>
            <span>{{ getCategoryLabel(download.categoryType) }}</span>
          </div>
          <div class="content">
            <div class="departamentoYFecha">
              <div>{{ getDepartmentLabel(download.departmentType) }}</div>
              <div>{{ formatDate(download.creationDate) }}</div>
            </div>
            <h3>{{ download.originalName }}</h3>
            <p>{{ download.description || "Sin descripción" }}</p>
          </div>
          <div class="acciones">
            <div class="wrapper">
              <button
                class="descargar"
                (click)="handleDownloadFile(download.id)"
              >
                <img
                  src="../../../assets/images/icons/download_white.svg"
                  alt="Descargar"
                />
                Descargar
              </button>
            </div>
          </div>
        </div>

        <div *ngIf="downloads.length === 0" class="noData">
          No hay descargas disponibles
        </div>
      </div>

      @if(hasData && totalItems > 0){
        <app-paginator
          [total]="totalItems"
          [pageSize]="filters.pageSize"
          [pageIndex]="filters.page - 1"
          (changePage)="onPageChange($event)"
        ></app-paginator>
      }

    </div>
  </div>
</main>

<!-- Filtros -->
<ng-template #template>
  <div class="wrapperG3">
    <div>
      <label>Título</label>
      <app-input
        [data]="{
          placeholder: 'Título',
          value: filterTitleDraft
        }"
        (textSearch)="onFilterChange({ originalName: $event })"
      ></app-input>
    </div>
    <div>
      <label>Descripción</label>
      <app-input
        [data]="{
          placeholder: 'Descripción',
          value: filterDescriptionDraft
        }"
        (textSearch)="onFilterChange({ description: $event })"
      ></app-input>
    </div>
    <div>
      <label>Categoría</label>
      <app-select
        [options]="categoryOptions"
        [placeholder]="'Buscar por categoría'"
        [resetSelect]="resetSelectTrigger"
        (optionSelected)="onFilterChange({ categoryType: $event })"
      ></app-select>
    </div>
    <div>
      <label>Departamento</label>
      <app-select
        [options]="departmentOptions"
        [placeholder]="'Buscar por departamento'"
        [resetSelect]="resetSelectTrigger"
        (optionSelected)="onDepartmentChange($event)"
      ></app-select>
    </div>
    <div>
      <app-date-picker
        [isRange]="true"
        label="Fecha de Creación"
        placeholderFrom="Desde"
        placeholderTo="Hasta"
        [selectedDateFrom]="filterDateFromDraft"
        [selectedDateTo]="filterDateToDraft"
        (selectedDateFromChange)="onDateChange('startDate', $event)"
        (selectedDateToChange)="onDateChange('endDate', $event)"
      ></app-date-picker>
    </div>
  </div>
  <div class="filtersActions">
    <button class="primary" (click)="search()">Buscar</button>
    <button class="secondary" (click)="clearFilters()">Limpiar filtros</button>
  </div>
</ng-template>
